var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.957,
    height: 27.814,
    viewBox: "0 0 28.957 27.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6242",
    "data-name": "Rectangle 6242",
    width: 28.957,
    height: 27.814,
    fill: "#dd052b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14822",
    "data-name": "Group 14822",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29509",
    "data-name": "Path 29509",
    d: "M28.957,17.2c-.094.564-.166,1.133-.285,1.692a10.983,10.983,0,0,1-1.5,3.634.57.57,0,1,1-.951-.607,9.961,9.961,0,0,0,1.5-4.191A10.065,10.065,0,0,0,24.85,9.164a10.283,10.283,0,1,0-9.333,17.3,10.07,10.07,0,0,0,7.438-1.328c.45-.274.761-.259.966.054s.077.632-.372.912A11.428,11.428,0,0,1,6.982,20.748a.42.42,0,0,0-.474-.31c-1.14.013-2.281.006-3.422.005a2.726,2.726,0,0,1-.311-.011.552.552,0,0,1-.514-.541.558.558,0,0,1,.516-.57,2.327,2.327,0,0,1,.282-.009H6.452L6.1,17.139H5.139c-.5,0-1,.006-1.5,0a.563.563,0,1,1,0-1.125c.716-.008,1.433,0,2.149,0h.3l.278-2.168H6.058q-2.63,0-5.26,0A1.657,1.657,0,0,1,.406,13.8a.554.554,0,0,1,.08-1.083,2.531,2.531,0,0,1,.311-.01c1.885,0,3.77,0,5.656,0a.332.332,0,0,0,.364-.253c.265-.64.557-1.27.846-1.921-.075,0-.164-.013-.252-.013-.961,0-1.923,0-2.884,0-.41,0-.671-.223-.672-.562S4.12,9.4,4.525,9.4c1.225,0,2.451,0,3.676,0a.538.538,0,0,0,.475-.217,11.245,11.245,0,0,1,6.118-3.876c.072-.018.141-.045.223-.072,0-.088.01-.172.011-.256,0-.386,0-.771,0-1.16A1.951,1.951,0,0,1,13.64,2.465,1.908,1.908,0,0,1,15.44.021C16.825-.011,18.212,0,19.6.019a1.9,1.9,0,0,1,1.864,1.653A1.9,1.9,0,0,1,20.23,3.733a.264.264,0,0,0-.212.3c.014.394,0,.79,0,1.16.67.232,1.337.408,1.958.687a11.255,11.255,0,0,1,6.875,9.039c.036.231.068.463.1.695ZM17.508,2.726c.64,0,1.28,0,1.92,0a1.331,1.331,0,0,0,.389-.046.777.777,0,0,0,.528-.836.8.8,0,0,0-.857-.7q-1.948-.009-3.9,0a.8.8,0,0,0-.89.807.791.791,0,0,0,.887.775c.64,0,1.28,0,1.92,0M16.175,5h2.7V3.877h-2.7Z",
    transform: "translate(0 0)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29510",
    "data-name": "Path 29510",
    d: "M133.5,109.62a8.77,8.77,0,1,1-8.77-8.777,8.787,8.787,0,0,1,8.77,8.777m-16.409-.029a7.639,7.639,0,1,0,7.661-7.616,7.655,7.655,0,0,0-7.661,7.616",
    transform: "translate(-107.199 -93.223)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29511",
    "data-name": "Path 29511",
    d: "M1.133,256.236a.557.557,0,0,1-.557.556.557.557,0,0,1-.57-.572.564.564,0,0,1,1.127.015",
    transform: "translate(-0.005 -236.357)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29512",
    "data-name": "Path 29512",
    d: "M326.272,311.681a.55.55,0,0,1,.575-.534.558.558,0,1,1-.048,1.115.551.551,0,0,1-.528-.581",
    transform: "translate(-301.619 -287.637)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29513",
    "data-name": "Path 29513",
    d: "M193.615,161.661a1.61,1.61,0,0,1,.089-.467c.136-.26.024-.4-.157-.572-.325-.3-.633-.62-.942-.937a.564.564,0,0,1-.04-.85.574.574,0,0,1,.832.047q.537.523,1.058,1.061a.266.266,0,0,0,.34.08,1.58,1.58,0,0,1,1.161-.007.307.307,0,0,0,.386-.1c.842-.851,1.684-1.7,2.543-2.534a.8.8,0,0,1,.537-.228.606.606,0,0,1,.438.321.792.792,0,0,1-.079.571,2.116,2.116,0,0,1-.423.45c-.733.734-1.463,1.469-2.2,2.2a.357.357,0,0,0-.11.433,1.749,1.749,0,0,1-2.366,2.144,1.772,1.772,0,0,1-1.065-1.611m1.773-.61a.615.615,0,0,0-.624.624.622.622,0,0,0,1.244,0,.616.616,0,0,0-.62-.628",
    transform: "translate(-177.854 -145.28)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29514",
    "data-name": "Path 29514",
    d: "M225.709,130.278c0,.1.007.207,0,.309a.555.555,0,0,1-.5.522.537.537,0,0,1-.6-.435,2.817,2.817,0,0,1-.005-.755.534.534,0,0,1,.587-.451.548.548,0,0,1,.519.53c.007.093,0,.187,0,.281",
    transform: "translate(-207.61 -119.684)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29515",
    "data-name": "Path 29515",
    d: "M298.558,210.657a2.609,2.609,0,0,1-.415-.052.557.557,0,0,1,.117-1.086,5.365,5.365,0,0,1,.562,0,.563.563,0,0,1,.575.537.576.576,0,0,1-.557.589c-.093.008-.187,0-.281,0l0,.015",
    transform: "translate(-275.254 -193.679)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29516",
    "data-name": "Path 29516",
    d: "M224.491,283.378c0-.094,0-.188,0-.281a.561.561,0,0,1,1.118-.044,3.371,3.371,0,0,1,0,.617.565.565,0,0,1-.581.533.571.571,0,0,1-.541-.573c0-.084,0-.169,0-.253",
    transform: "translate(-207.527 -261.202)",
    fill: "#dd052b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29517",
    "data-name": "Path 29517",
    d: "M145.358,209.407a2.67,2.67,0,0,1,.31,0,.535.535,0,0,1,.488.53.522.522,0,0,1-.447.563,3.028,3.028,0,0,1-.7.009.548.548,0,0,1-.5-.559.558.558,0,0,1,.537-.548c.1-.009.207,0,.311,0v0",
    transform: "translate(-133.591 -193.578)",
    fill: "#dd052b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.7551a6b318554d8625597a9509cf2f10.svg";
export { ForwardRef as ReactComponent };